import type { OrganizationContextHeaderProps } from "./organization-context-header.type";
import type { OrganizationContextSelectStyles } from "@/modules/organization/organization-context-select";

import { useElementSize } from "@/utilities/element";

export const useOrganizationContextHeaderSizes = ({
  dropdownPosition,
}: OrganizationContextHeaderProps) => {
  const { ref: containerRef, size: containerSize } = useElementSize();

  const selectStyles: OrganizationContextSelectStyles = {
    popup: {
      root: {
        top: dropdownPosition.top,
        left: dropdownPosition.left,
        minWidth: containerSize?.width,
      },
    },
  };

  return {
    containerRef,
    selectStyles,
  };
};
